// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"612":"f548d3dfb4fbe3c6ea3e","924":"b5b1a0cbedeed935b09a"}[chunkId] + ".js";
};